import service from '@services';
import { ProductNode, ProductPack, Order } from '@datamodel';

const PREFIX = '/orders';

export const list = async () => {
    const response = await service.get(`${PREFIX}/`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            orders: Order.parseArray(response.response)
        }
    }
    return service.error(response);
}

export const get = async (pk) => {
    const response = await service.get(`${PREFIX}/${pk}/`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            order: Order.parse(response.response)
        }
    }
    return service.error(response);
}

export const getPacks = async () => {
    const response = await service.get(`${PREFIX}/packs/`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            packs: ProductPack.parseArray(response.response)
        }
    }
    return service.error(response);
}

export const create = async (data) => {
    const response = await service.post(`${PREFIX}/`, {
        selections: data.selections,
        promotion_codes: data.promotion_codes,
        amount_off: data.amountOff,
        event: data.eventId,
        place: data.placeId,
        service_type: data.serviceType || 'standard',
        delivery_address: data.deliveryAddress,
        pickupbar: data.pickupBarId,
        started_at: data.startedAt,
        session_beacon: data.sessionBeacon,
        user_beacon: data.userBeacon
    });

    if (response.status === 'ok') {
        return {
            status: 'ok',
            order: Order.parse(response.response)
        }
    }
    throw service.error(response);
}

export const markAsPaid = async (pk) => {
    const response = await service.post(`${PREFIX}/${pk}/mark_as_paid/`);
    if (response.status === 'ok') {
        return {
            status: 'ok',
            order: Order.parse(response.response)
        }
    }
    return service.error(response);
}

export const cancel = async (pk) => {
    const response = await service.delete(`${PREFIX}/${pk}/`);
    if (response.status === 'ok') {
        return {
            status: 'ok'
        }
    }
    return service.error(response);
}